import React, { useContext } from 'react';
import { Typography } from 'antd';
import SearchContext from '../../../context';
import { Row, Col } from 'react-flexbox-grid';
import LangContext from '../../../context/LangContext';

const Capa = () => {

    const contextService = useContext(SearchContext);

    const { currentLangData } = useContext(LangContext);

    const { Title } = Typography;

    const capabilities = [

        {title: 'User Interface', emoji: '🎨', bullets: ['Theming', 'Flexbox build', 'Responsive', 'Styled Components', 'JSX', 'Pixel Perfect']},
        {title: 'Development', emoji: '👨🏼‍💻', bullets: ['Javascript', 'React / Angular', 'Jest Testing', 'Socket.io', 'REST API', 'Estructura de datos']}
    ]

    return(
        <div id="habilidades" className="capabilities-container main-container" style={{ paddingTop: '4rem', paddingBottom: '6rem', width: '100%', height: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }} >
            <div style={{ maxWidth: '48rem', height: 'auto', padding: '2rem 0rem', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column' }} >
                <Title className="main-title-color" style={{ paddingBottom: '.45em', fontSize: '2.55rem' }}>
                    {currentLangData.HABILIDADES.title}
                </Title>
            </div>
            <Row className="no-margin"style={{ padding: '0em 1.75em', width: '100%', height: 'auto', display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }} >
                {
                    capabilities.map((item, i) => {
                        return(
                            <Col className="no-padding" key={i} xs={12} sm={12} md={12} lg={4} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginBottom: contextService.width <= 991 ? '2.75em' : null }} >
                                <span style={{ fontSize: '4.5rem' }} >{item.emoji}</span>
                                <Title className="main-title-color" style={{ padding: '.45em 0', fontSize: '1.65rem' }} >{item.title}</Title>
                                {item.bullets.map((bullet, j) => {
                                    return(
                                        <span key={j} className="secondary-title-color" style={{ paddingTop: '.75em', fontSize: '1.15rem' }} >{bullet}</span>
                                    )
                                })}
                            </Col>
                        )
                    })
                }
            </Row>
        </div>
    )
}

export default Capa;